import jQuery from "jquery";
import DATA from "../data/data";
import templates from "../templates";
import MapView from "./mapView";
import SearchView from "./searchView";

import SERVICE_REGISTRY from "../services/registry";
import { DistanceProvider } from "../stores-js/location/distanceprovider";
import DetailView from "./detailView";
import DirectionsView from "./directionsView";
import ResultView from "./resultView";

const $ = jQuery;

export default class MainView extends woosmap.map.MVCObject {
    constructor(container, brands, country, filters, language, mapSearchQuery, autocompleteByName, business) {
        super();
        container.innerHTML = templates.mobile.main.render(total.maps.L10n.ui);
        this.selector = ".storemap-store-locator";

        this.stores = null;
        this.location = null;

        this.mainElement = document.querySelector(this.selector);

        this.VIEWS = {
            search: "search",
            map: "map",
            result: "result",
            detail: "detail",
            directions: "directions",
        };
        this.currentView = null;
        this.resultView = new ResultView(this);

        this.woosmapDistanceProvider = new DistanceProvider();
        this.woosmapDistanceProvider.bindTo("location", this);
        this.directionsView = new DirectionsView(this);
        this.mapView = new MapView(this, brands, country, filters, mapSearchQuery, (mapView) => {
            this.detailView = new DetailView(this, language);
        });

        this.mapView.onCenterChange(() => {
            this.resultView.onCenterChange();
        });

        this.searchView = new SearchView(this, filters, brands, autocompleteByName, business);
        if (mapSearchQuery) {
            // Not sure about formatedString so not remove if for now
            // eslint-disable-next-line no-unused-vars
            DATA.woosGeocode(mapSearchQuery, (bounds, location, formatedString) => {
                SERVICE_REGISTRY.locationService.setLocation(location, mapSearchQuery);
                this.setSearchViewInputSearchText(mapSearchQuery);
            });
        }
        this.showSearch();
        this._wireEvents(country);
    }

    _wireEvents(country) {
        const onEnterButtonClick = () => {
            this.showMap("store", undefined, country);
        };

        const onSearchNavigationBarClick = () => {
            // this.mapView.clearDirectionMap();
            // this.directionsView.cleanDirectionData();
            this.showSearch();
        };

        const onMapNavigationBarClick = () => {
            this.mapView.clearDirectionMap();
            this.directionsView.cleanDirectionData();
            this.showMap();
        };

        const onListNavigationBarClick = () => {
            this.mapView.clearDirectionMap();
            this.directionsView.cleanDirectionData();
            this.showResult();
        };

        this.mainElement.querySelector("#storemap-enterbar-container").addEventListener("click", onEnterButtonClick);
        this.mainElement
            .querySelector("#storemap-navbar-container .storemap-navbar-newsearch-button")
            .addEventListener("click", onSearchNavigationBarClick);
        this.mainElement
            .querySelector("#storemap-navbar-container .storemap-navbar-storemap-button")
            .addEventListener("click", onMapNavigationBarClick);
        this.mainElement
            .querySelector("#storemap-navbar-container .storemap-navbar-storelist-button")
            .addEventListener("click", onListNavigationBarClick);

        SERVICE_REGISTRY.filterService.onQueryFilterChange((tags, types) => {
            this.mapView.onQueryFilterChange(tags, types);
            this.searchView.onQueryFilterChange(tags, types);
        });

        SERVICE_REGISTRY.storeService.onNearbyStoresChange((stores) => {
            this.resultView.onStoresChange(stores);
            this.mapView.onNearbyStoresChange(stores);
        });

        SERVICE_REGISTRY.storeService.onItinaryStoresChange((stores) => {
            this.resultView.onStoresChange(stores);
            this.mapView.onItinaryStoresChange(stores);
            this.mainElement.querySelector("#storemap-enterbar-container").click();
        });

        SERVICE_REGISTRY.locationService.onLocationChange((location) => {
            this.mapView.onLocationChange(location);
            this.searchView.onLocationChange(location);
            SERVICE_REGISTRY.storeService.setLocation(location);
        });
        SERVICE_REGISTRY.storeService.onUniqueStoreChange((store) => {
            this.mapView.onUniqueStoreChange(store);
            this.mapView.onSelectedStoreChanged(store);
        });
    }

    onRefreshList() {
        this.searchView.onRefreshList();
    }

    _hideAllViews() {
        const divsToHide = this.mainElement.querySelectorAll(":scope > div");

        for (const divToHide of divsToHide) {
            divToHide.style.display = "none";
        }
    }

    showSearch() {
        this.currentView = this.VIEWS.search;
        this._hideAllViews();
        this.showEnterButton();
        this.searchView.show();
    }

    showMap(sliderName, index, country) {
        this.currentView = this.VIEWS.map;
        this._hideAllViews();
        this.showNavigation("list");
        this.mapView.show(sliderName, index, country);
    }

    showResult() {
        this.currentView = this.VIEWS.result;
        this._hideAllViews();
        this.showNavigation("map");
        this.resultView.show();
    }

    showDetail() {
        this.currentView = this.VIEWS.detail;
        this._hideAllViews();
        this.showNavigation("map");
        this.detailView.show();
    }

    showDirection() {
        this.currentView = this.VIEWS.directions;
        this._hideAllViews();
        this.showNavigation("map");
        this.directionsView.show();
    }

    showNavigation(secondElementCode) {
        if (secondElementCode === "map") {
            this.mainElement.querySelector(
                "#storemap-navbar-container .storemap-navbar-storelist-button",
            ).style.display = "none";
            this.mainElement.querySelector(
                "#storemap-navbar-container .storemap-navbar-storemap-button",
            ).style.display = "";
        } else if (secondElementCode === "list") {
            this.mainElement.querySelector(
                "#storemap-navbar-container .storemap-navbar-storelist-button",
            ).style.display = "";
            this.mainElement.querySelector(
                "#storemap-navbar-container .storemap-navbar-storemap-button",
            ).style.display = "none";
        }
        this.mainElement.querySelector("#storemap-navbar-container").style.display = "";
    }

    showEnterButton() {
        this.mainElement.querySelector("#storemap-enterbar-container").style.display = "";
    }

    updateStoreDistance(stores, callback) {
        const location = this.get("location");

        if (location !== null && !$.isEmptyObject(location)) {
            // this.woosmapDistanceProvider.updateStoresDistanceWithGoogle(stores, callback);
            DATA.updateStoresWithWoosmapDistanceApi(stores, callback);
        } else {
            callback();
        }
    }

    updateMainLocation(location) {
        if (location) {
            this.mapView.updateMainLocation(location);
        }
    }

    resetOnRouteView() {
        this.mapView.resetOnRouteView();
    }

    getMainLocation() {
        return this.mapView.getMainLocation();
    }

    setStoreDetails(store) {
        this.detailView.hydrateStoreDetail(store);
    }

    clearMainLocation() {
        this.mapView.clearMainLocation();
    }

    getSelectedStore() {
        return this.mapView.getSelectedStore();
    }

    updateUserDirectionLocation(location) {
        this.mapView.updateUserDirectionLocation(location);
    }
    updateDestination(store) {
        this.mapView.updateDestination(store);
    }

    onDirectionsChange(directions) {
        this.directionsView.onDirectionsChange(directions);
    }

    updateDirectionTravelMode(travelMode) {
        this.mapView.updateDirectionTravelMode(travelMode);
    }

    getDirectionTravelMode() {
        return this.mapView.getDirectionTravelMode();
    }

    toggleOriginDestination() {
        this.mapView.toggleOriginDestination();
    }

    generateGoogleMapsDirectionUrl(index) {
        return this.mapView.generateGoogleMapsDirectionUrl(index);
    }

    generateWazeDirectionUrl(index) {
        return this.mapView.generateWazeDirectionUrl(index);
    }

    setSelectedStore(store) {
        return this.mapView.setSelectedStore(store);
    }

    setSearchViewInputSearchText(text) {
        this.searchView.setInputSearchText(text);
    }

    setDirectionViewInputSearchText() {
        this.directionsView.setInputSearchText();
    }

    setStores(stores) {
        this.mapView.setStores(stores);
    }

    getNavigatorLocation(callback) {
        const geoLocationProvider = navigator.geolocation;
        if (geoLocationProvider) {
            geoLocationProvider.getCurrentPosition(
                (position) => {
                    callback({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                },
                () => {
                    callback(null);
                },
            );
        } else {
            callback(null);
        }
    }
}
